import type { Chat, UserStatus } from "./types";

export function formatDate(value: string | null | undefined, fallback = "-") {
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return new Intl.DateTimeFormat("ru", { dateStyle: "medium", timeStyle: "short" }).format(date);
}

export function formatNumber(value: number | null | undefined) {
  return value === null || value === undefined ? "-" : value.toLocaleString("ru-RU");
}

export function chatName(chat: Pick<Chat, "id" | "title" | "username">) {
  return chat.title || chat.username || `Чат ${chat.id}`;
}

export function userName(user: { first_name?: string | null; last_name?: string | null; username?: string | null; id: number }) {
  return [user.first_name, user.last_name].filter(Boolean).join(" ") || (user.username ? `@${user.username}` : `ID ${user.id}`);
}

export const statusLabels: Record<UserStatus, string> = {
  admin: "Администратор",
  approved: "Доверенный",
  spamer: "Спамер",
  unknown: "Без статуса"
};

export function errorText(error: unknown, fallback: string) {
  if (error instanceof DOMException && error.name === "AbortError") return "";
  return error instanceof Error ? error.message : fallback;
}
